import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import HorizontalBarChart from '../../../../components/admin/reports/charts/HorizontalBarChart';
import KpiStatRow from '../../../../components/admin/reports/charts/KpiStatRow';

export default function SocialDiscountsSection({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_SOCIAL_DISCOUNTS,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });
    const stateData = data?.state_distribution || [];

    return (
        <>
            <div style={{marginBottom: 16}}>
                <KpiStatRow
                    loading={isLoading}
                    items={[
                        {title: 'Pacientes com Desconto Social', value: data?.patients_with_social_discount ?? 0},
                        {title: '% com Desconto Social', value: data?.percentage ?? 0, precision: 2, suffix: '%'},
                        {title: 'Total de Pacientes', value: data?.total_patients ?? 0},
                    ]}
                />
            </div>
            <ReportChartCard title="Desconto Social por Estado" loading={isLoading} isEmpty={!stateData.length}>
                <HorizontalBarChart data={stateData} dataKey="count" nameKey="state"/>
            </ReportChartCard>
        </>
    );
}
